import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Contact from '../../entities/contact';
import Matter from '../../entities/matter';
import Conflict from '../../entities/conflict';
import Expense from '../../entities/expense';
import FlatFee from '../../entities/flatFee';
import Lead from '../../entities/lead';
import Participant from '../../entities/participant';
import Referral from '../../entities/referral';
import Task from '../../entities/task';
import Transaction from '../../entities/transaction';
import User from '../../entities/user';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
import Identification from '../../entities/identification';
import Event from '../../entities/event';

/*
 * Delete/nullify anywhere this contact is used in other entities
 *
 * @param {Contact} contact
 */
export function deleteContact(contact: Contact, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = contact.id;
    }
    /* Simple delete usages */
        
    store.getState().matters
        .getMappingFor('contactId', contact.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.clients = _matter.clients?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().matters
        .getMappingFor('billToContactId', contact.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.billToContactId = null;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().conflicts
        .getMappingFor('contactId', contact.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.checkedContactIds = _conflict.checkedContactIds?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().contacts
        .getMappingFor('contactId', contact.id)
        .filter(contactTemp => contactTemp.status !== 'D')
        .forEach(contactTemp => {
            const _contact = contactTemp.clone();
            _contact.status =  'U';
            _contact.addedOn = newHRTimestamp();
            _contact.addedBy = getCurrentUserId();
            _contact.importSource = targetImportSource;
            _contact.importId = mergeId;

            _contact.companyId = null;
            store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
        });

    store.getState().expenses
        .getMappingFor('contactId', contact.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.payee = null;
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().flatFees
        .getMappingFor('contactId', contact.id)
        .filter(flatFeeTemp => flatFeeTemp.status !== 'D')
        .forEach(flatFeeTemp => {
            const _flatFee = flatFeeTemp.clone();
            _flatFee.status =  'U';
            _flatFee.addedOn = newHRTimestamp();
            _flatFee.addedBy = getCurrentUserId();
            _flatFee.importSource = targetImportSource;
            _flatFee.importId = mergeId;

            _flatFee.relatedTo = null;
            store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.clients = _lead.clients?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.payers = _lead.payers?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.referrers = _lead.referrers?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().participants
        .getMappingFor('contactId', contact.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.contactId = '';
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().referrals
        .getMappingFor('contactId', contact.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.referee = null;
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    store.getState().tasks
        .getMappingFor('contactId', contact.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.relatedTo = _task.relatedTo?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().transactions
        .getMappingFor('contactId', contact.id)
        .filter(transactionTemp => transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            _transaction.status =  'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;

            _transaction.clientIds = _transaction.clientIds?.filter(id => id !== contact.id) || [];
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    store.getState().users
        .getMappingFor('contactId', contact.id)
        .filter(userTemp => userTemp.status !== 'D')
        .forEach(userTemp => {
            const _user = userTemp.clone();
            _user.status =  'U';
            _user.addedOn = newHRTimestamp();
            _user.addedBy = getCurrentUserId();
            _user.importSource = targetImportSource;
            _user.importId = mergeId;

            _user.contactId = null;
            store.dispatch(Actions.UserActions.saveUserQueue(_user));
        });

    /* Complex delete usages */
        /* - Delete key/value usages */
    
    findAll<Transaction>('transactions')
        .filter(transactionTemp => ['C','G'].includes(transactionTemp.sourceType || '') && transactionTemp.source === contact.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    findAll<Transaction>('transactions')
        .filter(transactionTemp => ['C','G'].includes(transactionTemp.targetType || '') && transactionTemp.target === contact.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Update the target with a null in the field (do NOT delete!)
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    /* Remove the actual contact */
    contact.status = 'D';
    contact.addedOn = newHRTimestamp();
    contact.addedBy = getCurrentUserId();
    contact.importSource = targetImportSource;
    contact.importId = mergeId;
    store.dispatch(Actions.ContactActions.removeContactQueue(contact));
    

    /* Delete any documents */
    findAll<Document>('documents')
         .filter(documentTemp => documentTemp.entityType === 'contact' && documentTemp.entityId === contact.id && documentTemp.status !== 'D')
         .forEach(documentTemp => {
            const _document = documentTemp.clone();
            // Delete the target
            _document.status = 'D';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;
            store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
         });
    

    /* Delete any comments */
    findAll<Comment>('comments')
         .filter(commentTemp => commentTemp.entityType === 'contact' && commentTemp.entityId === contact.id && commentTemp.status !== 'D')
         .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            // Delete the target
            _comment.status = 'D';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;
            store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
         });
    

    /* Delete any identifications */
    findAll<Identification>('identifications')
         .filter(identificationTemp => identificationTemp.entityType === 'contact' && identificationTemp.entityId === contact.id && identificationTemp.status !== 'D')
         .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            // Delete the target
            _identification.status = 'D';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;
            store.dispatch(Actions.IdentificationActions.removeIdentificationQueue(_identification));
         });
    

    /* Delete any events */
    findAll<Event>('events')
         .filter(eventTemp => eventTemp.entityType === 'contact' && eventTemp.entityId === contact.id && eventTemp.status !== 'D')
         .forEach(eventTemp => {
            const _event = eventTemp.clone();
            // Delete the target
            _event.status = 'D';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;
            store.dispatch(Actions.EventActions.removeEventQueue(_event));
         });
    

    /* Delete any participants */
    findAll<Participant>('participants')
         .filter(participantTemp => participantTemp.entityType === 'contact' && participantTemp.entityId === contact.id && participantTemp.status !== 'D')
         .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            // Delete the target
            _participant.status = 'D';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;
            store.dispatch(Actions.ParticipantActions.removeParticipantQueue(_participant));
         });
    
}

/*
 * Replace anywhere this contact is used in other entities.
 *
 * @param {Contact} contact
 * @param {Contact} replaceWith
 * @return {Contact} - Contact will have refs stripped away
 */
export function replaceContact(contact: Contact, replaceWith: Contact, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = contact.id;
    }
    /* Simple replace usages */
        
    store.getState().matters
        .getMappingFor('contactId', contact.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.clients = _matter.clients?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().matters
        .getMappingFor('billToContactId', contact.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.billToContactId = replaceWith.id;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().conflicts
        .getMappingFor('contactId', contact.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.checkedContactIds = _conflict.checkedContactIds?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().contacts
        .getMappingFor('contactId', contact.id)
        .filter(contactTemp => contactTemp.status !== 'D')
        .forEach(contactTemp => {
            const _contact = contactTemp.clone();
            _contact.status =  'U';
            _contact.addedOn = newHRTimestamp();
            _contact.addedBy = getCurrentUserId();
            _contact.importSource = targetImportSource;
            _contact.importId = mergeId;

            _contact.companyId = replaceWith.id;
            store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
        });

    store.getState().expenses
        .getMappingFor('contactId', contact.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.payee = replaceWith.id;
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().flatFees
        .getMappingFor('contactId', contact.id)
        .filter(flatFeeTemp => flatFeeTemp.status !== 'D')
        .forEach(flatFeeTemp => {
            const _flatFee = flatFeeTemp.clone();
            _flatFee.status =  'U';
            _flatFee.addedOn = newHRTimestamp();
            _flatFee.addedBy = getCurrentUserId();
            _flatFee.importSource = targetImportSource;
            _flatFee.importId = mergeId;

            _flatFee.relatedTo = replaceWith.id;
            store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.clients = _lead.clients?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.payers = _lead.payers?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().leads
        .getMappingFor('contactId', contact.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.referrers = _lead.referrers?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().participants
        .getMappingFor('contactId', contact.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.contactId = replaceWith.id;
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().referrals
        .getMappingFor('contactId', contact.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.referee = replaceWith.id;
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    store.getState().tasks
        .getMappingFor('contactId', contact.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.relatedTo = _task.relatedTo?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().transactions
        .getMappingFor('contactId', contact.id)
        .filter(transactionTemp => transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            _transaction.status =  'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;

            _transaction.clientIds = _transaction.clientIds?.map(id => (id === contact.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    store.getState().users
        .getMappingFor('contactId', contact.id)
        .filter(userTemp => userTemp.status !== 'D')
        .forEach(userTemp => {
            const _user = userTemp.clone();
            _user.status =  'U';
            _user.addedOn = newHRTimestamp();
            _user.addedBy = getCurrentUserId();
            _user.importSource = targetImportSource;
            _user.importId = mergeId;

            _user.contactId = replaceWith.id;
            store.dispatch(Actions.UserActions.saveUserQueue(_user));
        });

    /* Complex replace usages */
        /* - Modify key/value usages */
    
    findAll<Transaction>('transactions')
        .filter(transactionTemp => ['C','G'].includes(transactionTemp.sourceType || '') && transactionTemp.source === contact.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Replace the target with the new ID
			_transaction.source = replaceWith.id;
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    findAll<Transaction>('transactions')
        .filter(transactionTemp => ['C','G'].includes(transactionTemp.targetType || '') && transactionTemp.target === contact.id && transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            // Replace the target with the new ID
			_transaction.target = replaceWith.id;
            _transaction.status = 'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    /* Move any documents */
    findAll<Document>('documents')
         .filter(documentTemp => documentTemp.entityType === 'contact' && documentTemp.entityId === contact.id && documentTemp.status !== 'D')
         .forEach(documentTemp => {
            const _document = documentTemp.clone();
            // Replace the target with the new ID
			_document.entityId = replaceWith.id;
            _document.status = 'U';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
         });
    

    /* Move any comments */
    findAll<Comment>('comments')
         .filter(commentTemp => commentTemp.entityType === 'contact' && commentTemp.entityId === contact.id && commentTemp.status !== 'D')
         .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            // Replace the target with the new ID
			_comment.entityId = replaceWith.id;
            _comment.status = 'U';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;
            store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
         });
    

    /* Move any identifications */
    findAll<Identification>('identifications')
         .filter(identificationTemp => identificationTemp.entityType === 'contact' && identificationTemp.entityId === contact.id && identificationTemp.status !== 'D')
         .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            // Replace the target with the new ID
			_identification.entityId = replaceWith.id;
            _identification.status = 'U';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
         });
    

    /* Move any events */
    findAll<Event>('events')
         .filter(eventTemp => eventTemp.entityType === 'contact' && eventTemp.entityId === contact.id && eventTemp.status !== 'D')
         .forEach(eventTemp => {
            const _event = eventTemp.clone();
            // Replace the target with the new ID
			_event.entityId = replaceWith.id;
            _event.status = 'U';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
         });
    

    /* Move any participants */
    findAll<Participant>('participants')
         .filter(participantTemp => participantTemp.entityType === 'contact' && participantTemp.entityId === contact.id && participantTemp.status !== 'D')
         .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            // Replace the target with the new ID
			_participant.entityId = replaceWith.id;
            _participant.status = 'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
         });
    
    return contact;
}

/*
 * Determine the impact of deleting this contact from other entities
 *
 * @param {Contact} contact
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactContact(contact: Contact) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const matterClientsImpact = state.matters
          .getMappingFor('contactId', contact.id)
          .filter(matter => matter.status !== 'D');

    matterClientsImpact.forEach(() => impacts.push('matters*'));

    const matterBillToContactIdImpact = state.matters
          .getMappingFor('billToContactId', contact.id)
          .filter(matter => matter.status !== 'D');

    matterBillToContactIdImpact.forEach(() => impacts.push('matters'));

    const conflictCheckedContactIdsImpact = state.conflicts
          .getMappingFor('contactId', contact.id)
          .filter(conflict => conflict.status !== 'D');

    conflictCheckedContactIdsImpact.forEach(() => impacts.push('conflicts'));

    const contactCompanyIdImpact = state.contacts
          .getMappingFor('contactId', contact.id)
          .filter(contact => contact.status !== 'D');

    contactCompanyIdImpact.forEach(() => impacts.push('contacts'));

    const expensePayeeImpact = state.expenses
          .getMappingFor('contactId', contact.id)
          .filter(expense => expense.status !== 'D');

    expensePayeeImpact.forEach(() => impacts.push('expenses'));

    const flatFeeRelatedToImpact = state.flatFees
          .getMappingFor('contactId', contact.id)
          .filter(flatFee => flatFee.status !== 'D');

    flatFeeRelatedToImpact.forEach(() => impacts.push('flatFees'));

    const leadClientsImpact = state.leads
          .getMappingFor('contactId', contact.id)
          .filter(lead => lead.status !== 'D');

    leadClientsImpact.forEach(() => impacts.push('leads*'));

    const leadPayersImpact = state.leads
          .getMappingFor('contactId', contact.id)
          .filter(lead => lead.status !== 'D');

    leadPayersImpact.forEach(() => impacts.push('leads'));

    const leadReferrersImpact = state.leads
          .getMappingFor('contactId', contact.id)
          .filter(lead => lead.status !== 'D');

    leadReferrersImpact.forEach(() => impacts.push('leads'));

    const participantContactIdImpact = state.participants
          .getMappingFor('contactId', contact.id)
          .filter(participant => participant.status !== 'D');

    participantContactIdImpact.forEach(() => impacts.push('participants*'));

    const referralRefereeImpact = state.referrals
          .getMappingFor('contactId', contact.id)
          .filter(referral => referral.status !== 'D');

    referralRefereeImpact.forEach(() => impacts.push('referrals'));

    const taskRelatedToImpact = state.tasks
          .getMappingFor('contactId', contact.id)
          .filter(task => task.status !== 'D');

    taskRelatedToImpact.forEach(() => impacts.push('tasks'));

    const transactionClientIdsImpact = state.transactions
          .getMappingFor('contactId', contact.id)
          .filter(transaction => transaction.status !== 'D');

    transactionClientIdsImpact.forEach(() => impacts.push('transactions*'));

    const userContactIdImpact = state.users
          .getMappingFor('contactId', contact.id)
          .filter(user => user.status !== 'D');

    userContactIdImpact.forEach(() => impacts.push('users'));

    /* Complex delete usages */
        /* - Impact key/value usages */
    
    const transactionSourceTypeImpact = findAll<Transaction>('transactions')
        .filter(transaction => ['C','G'].includes(transaction.sourceType || '') && transaction.source === contact.id && transaction.status !== 'D');
    transactionSourceTypeImpact.forEach(() => impacts.push('transactions'));

    const transactionTargetTypeImpact = findAll<Transaction>('transactions')
        .filter(transaction => ['C','G'].includes(transaction.targetType || '') && transaction.target === contact.id && transaction.status !== 'D');
    transactionTargetTypeImpact.forEach(() => impacts.push('transactions*'));

    return util.countDistinct(impacts);
}